import React, { useEffect, useState } from "react";
import "./MyTransports.scss";
import ImagesView from "../../../components/image-gallery";
import { Link } from "react-router-dom";
import { getTranspotListService } from "../../../services/AdminService";
import { PagePagination } from "../../../components/pagination";
import { ListItemPlaceholder } from "../../../components/skeleton-placeholder";
import { NoDataFound } from "../../../components/no-data-found";
import { SelectField } from "../../../components/sorting";
import ReadMoreLess from "../../../components/read-more-less";
import { useAuth } from "../../../contexts/AuthProvider";
import { Nav } from "react-bootstrap";
import DurationComponent from "../../../components/departure-arrival-duration";

const MyTransports = () => {
  const { currencyData } = useAuth();
  const [transportList, setTransportList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(1);
  const [sortName, setSortName] = useState("");
  const [types, setTypes] = useState("All");
  const newCurrency = currencyData?.currency;
  const sortOptions = [
    { value: "name", name: "Name (A to Z)" },
    { value: "pricelowtohigh", name: "Price (Low to High)" },
    { value: "pricehightolow", name: "Price (High to Low)" },
  ];

  const getTransportListFunc = async ({
    page,
    pageSize,
    shortName,
    newCurrency,
    types,
  }) => {
    setIsLoading(true);
    setCurrentPage(page);
    await getTranspotListService(
      { page, pageSize, shortName, newCurrency, types },
      (res) => {
        if (res.status === 200) {
          // console.log("===== Response Transport Data =====>", res.data);
          const { data, paginationData } = res.data;
          setTransportList(data);
          setTotalItems(paginationData.totalItems);
          setPageSize(paginationData.pageSize);
        } else {
          console.log(
            `Error: ${res.data?.message || "An unexpected error occurred."}`
          );
        }
        setIsLoading(false);
      }
    );
  };

  const onChangePaginate = (number) => {
    getTransportListFunc({
      page: number,
      pageSize,
      shortName: sortName,
      newCurrency,
      types,
    });
  };

  const handleSortChange = (e) => {
    setSortName(e.target.value);
    getTransportListFunc({
      page: currentPage,
      pageSize,
      shortName: e.target.value,
      newCurrency,
      types,
    });
  };

  const handleSelectTypeChange = (selectedKey) => {
    setTypes(selectedKey);
    getTransportListFunc({
      page: currentPage,
      pageSize,
      shortName: sortName,
      newCurrency,
      types: selectedKey,
    });
  };

  useEffect(() => {
    getTransportListFunc({
      page: 1,
      pageSize,
      shortName: "",
      newCurrency,
      types: "",
    });
  }, []);

  return (
    <>
      <div className="content-body">
        <div className="d-header-block my-transport-header mb-4">
          <h1 className="d-col-title">My Transports</h1>
          <Nav className="fliter-transport" activeKey={types} onSelect={handleSelectTypeChange}>
            <Nav.Item>
              <Nav.Link eventKey="All">All</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="Car">Car</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="Flight">Flight</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="Train">Train</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="Others">Others</Nav.Link>
            </Nav.Item>
          </Nav>
          <SelectField
            fieldName="sort"
            options={sortOptions}
            onChangeSelect={handleSortChange}
          />
        </div>
        {isLoading ? (
          <ListItemPlaceholder number={pageSize} />
        ) : (
          <>
            {transportList.length > 0 ? (
              <div className="item-row">
                {transportList.map((item, index) => {
                  return (
                    <div key={item._id} className="item-block">
                      <div className="item-img-block">
                        <ImagesView imagesData={item.icon} />
                      </div>
                      <div className="item-content-block">
                        <div className="item-info">
                          <h4 className="mb-2">{item.name}</h4>
                          <DurationComponent item={item} />
                          <div className="list-row mt-2">
                            <div className="list-col w-50">
                              {item?.types[0]} Type :{" "}
                              <span>
                                {item.vehicleType ? item.vehicleType : "N/A"}
                              </span>
                            </div>
                            <div className="list-col w-50">
                              Status :{" "}
                              {item.status ? <span>{item.status}</span> : "N/A"}
                            </div>
                            <div className="list-col w-50">
                              Estimated Cost :{" "}
                              <span>
                                {item.currencyConvert
                                  ? Math.floor(item.currencyConvert.new_amount)
                                  : Math.floor(item.amount)}{" "}
                                {item.currencyConvert
                                  ? item.currencyConvert.new_currency
                                  : item.currency}
                              </span>
                            </div>
                            <div className="list-col w-50">
                              Location :{" "}
                              <a
                                href={`https://www.google.com/maps/dir/${item?.from_address?.location?.coordinates[0]},${item?.from_address?.location?.coordinates[1]}/${item?.to_address?.location?.coordinates[0]},${item?.to_address?.location?.coordinates[1]}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="link-text">
                                View Map
                              </a>
                            </div>
                            {item.itinerary && (
                              <div className="list-col w-100">
                                Itinerary Name:{" "}
                                <span>
                                  <Link
                                    to={`/admin/itinerary-preview/?itineraryId=${item.itinerary._id}`}
                                  >
                                    {item.itinerary.tour_name}
                                  </Link>
                                </span>
                              </div>
                            )}
                            {item.description && (
                              <div className="list-col w-100">
                                <ReadMoreLess
                                  key={index}
                                  truncLength={150}
                                  text={item.description}
                                />
                              </div>
                            )}
                            {item.websiteLink && (
                              <div className="list-col mt-2 w-100">
                                <span>
                                  <a
                                    href={item?.websiteLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="link-text"
                                  ><i className="bi bi-laptop-fill"></i> See Details</a>
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <NoDataFound />
            )}
          </>
        )}
        {transportList.length > 0 && (
          <PagePagination
            totalItems={totalItems}
            currentPage={currentPage}
            pageSize={pageSize}
            onPageChange={onChangePaginate}
            loading={isLoading}
          />
        )}
      </div>
    </>
  );
};

export default MyTransports;
